import { api } from "@/lib/api";
import { textKey, ORDER_NEW } from "@/lib/store";

const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
const money = (v) => brl.format(Number(v) || 0);

let cache = null;

export const fetchOrderPrices = (force = false) => {
  if (!cache || force) {
    cache = api.get("/order-prices").then((r) => (Array.isArray(r?.data) ? r.data : []));
    cache.catch(() => { cache = null; });
  }
  return cache;
};

export const conditionKey = (label) => (label === ORDER_NEW ? "novo" : "seminovo");

export const findPrice = (list, model, storage, condition) => (Array.isArray(list) ? list : []).find((p) =>
  textKey(p.model) === textKey(model) && p.storage === storage && p.condition === condition) || null;

export const formatRange = (p) => (p.min === p.max ? money(p.min) : `${money(p.min)} a ${money(p.max)}`);
